module.exports = __webpack_public_path__ + "icon.aee23d13d1efa26f65d7.woff";


//////////////////
// WEBPACK FOOTER
// E:/PROJETO SUFRAMA/DESENVOLVIMENTO/Projetos/SCIEX/sciex/src/Suframa.Sciex.UserInterface/www/assets/fonts/icon.woff
// module id = ../../../../../www/assets/fonts/icon.woff
// module chunks = styles